import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'velocity-error-robot',
  templateUrl: './error-robot.component.html',
  styleUrls: ['./error-robot.component.scss']
})
export class ErrorRobotComponent implements OnInit {

  @Input() errorText: string = "ERROR";
  @Input() size: string = "large";

  ngOnInit() {
  }

}
